import React from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import { prjDeptHeaderTyps } from '../../utils/forecastStaticData';
import { getNumberComma } from '../../utils/numberUtils';

const GoalStaticTableCell = ({ data, headerRows }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    headerRows &&
    headerRows.map((field, fIndex) => {
      let value = _.has(data, field) ? data[field] : '-';
      let formatValue = getNumberComma(value);

      return (
        <TableCell
          sx={{ width: '100px', paddingLeft: 0 }}
          align="right"
          key={fIndex}
        >
          {formatValue}
        </TableCell>
      );
    })
  );
};

export default GoalStaticTableCell;
